import Vue from 'vue'
import VueRouter from 'vue-router'
import Aidex from '@/views/Aidex.vue'
import AidexMg from '@/views/AidexMg.vue'
import AidexToC from '@/views/AidexToC.vue'
import AidexMgToC from '@/views/AidexMgToC.vue'

Vue.use(VueRouter)

const routes = [
  // mmol/L aidex
  {
    path: '/aidex',
    name: 'Aidex',
    component: Aidex
  },
  // mg/dL版本 aidex
  {
    path: '/mg/aidex',
    name: 'AidexMg',
    component: AidexMg
  },
  // mmol/L 国内aidex 2c版本
  {
    path: '/aidex/2c',
    name: 'AidexToC',
    component: AidexToC
  },
  // mg/dL 国内aidex版本
  {
    path: '/mg/aidex/2c',
    name: 'AidexMgToC',
    component: AidexMgToC
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
